<template>
  <section class="page my-order">
    <div class="header-tabs">
      <el-tabs v-model="activeTab" @tab-click="switchTab">
        <el-tab-pane
          :label="` 全部订单 ( ${tabModels[0].total} )`"
          name="全部订单"
        >
          <div class="list-wrap">
            <order-table :orderList="tabModels[0].dataList"></order-table>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="` 待付款 ( ${tabModels[1].total} )`" name="待付款">
          <div class="list-wrap">
            <order-table :orderList="tabModels[1].dataList"></order-table>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="` 待评价 ( ${tabModels[2].total} )`" name="待评价">
          <div class="list-wrap">
            <order-table :orderList="tabModels[2].dataList"></order-table>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="` 已完成 ( ${tabModels[3].total} )`" name="已完成">
          <div class="list-wrap">
            <order-table :orderList="tabModels[3].dataList"></order-table>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="` 已取消 ( ${tabModels[4].total} )`" name="已取消">
          <div class="list-wrap">
            <order-table :orderList="tabModels[4].dataList"></order-table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="header-right">
        <div class="custom-search">
          <input
            type="text"
            class="custom-input"
            placeholder="请输入订单号"
            v-model.trim="tabModels[currentTabIndex].searchParams.keyword"
            @keyup.enter="
              handleSearch(tabModels[currentTabIndex].searchParams.keyword)
            "
          />
          <el-button
            type="primary"
            icon="el-icon-search"
            class="custom-button"
            @click="
              handleSearch(tabModels[currentTabIndex].searchParams.keyword)
            "
            >搜索
          </el-button>
        </div>
      </div>
    </div>
    <div class="pagination-box">
      <el-pagination
        class="ou-pagination"
        background
        hide-on-single-page
        @size-change="changePageSize"
        @current-change="changePageCurrent"
        :current-page="tabModels[currentTabIndex].searchParams.pageNum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="tabModels[currentTabIndex].searchParams.pageSize"
        layout="total, prev, pager, next, sizes, jumper, slot"
        :total="tabModels[currentTabIndex].total"
      >
        <el-button @click="getCurrentTabList" class="ou-page-go">GO</el-button>
      </el-pagination>
      <!-- <el-button @click="getCurrentTabList" class="ou-page-go">GO</el-button> -->
    </div>
    <el-dialog
      key="__myOrder__"
      title="付款"
      :visible.sync="modalShow"
      width="500px"
      append-to-body
      :destroy-on-close="true"
      class="ou-modal pay-modal"
      @close="closed"
    >
      <div class="pay-modal-wrap">
        <div class="info-row">
          支付金额：<span class="price-span">{{
            (payDetail.payment || 0) | paymentText
          }}</span>
        </div>
        <div class="info-row">支付方式：</div>
        <div class="pay-way-wrap">
          <div
            class="pay-box"
            @click="selectWay('wx')"
            :class="[selectedWay === 'wx' ? 'active' : '']"
          >
            <div class="box-wrap">
              <el-image
                :src="require('@/assets/icon/wxpay.png')"
                fit="contain"
              ></el-image>
            </div>
            <el-image
              v-show="selectedWay === 'wx'"
              class="select-flag"
              :src="require('@/assets/icon/btn-pay-corner.png')"
              fit="contain"
            ></el-image>
          </div>
          <div
            class="pay-box"
            @click="selectWay('ali')"
            :class="[selectedWay === 'ali' ? 'active' : '']"
          >
            <div class="box-wrap">
              <el-image
                :src="require('@/assets/icon/alipay.png')"
                fit="contain"
              ></el-image>
            </div>
            <el-image
              v-show="selectedWay === 'ali'"
              class="select-flag"
              :src="require('@/assets/icon/btn-pay-corner.png')"
              fit="contain"
            ></el-image>
          </div>
        </div>
        <div v-show="selectedWay !== ''">
          <div class="info-row">扫码支付：</div>
          <div class="qrcode-box">
            <div id="qrcode2-myOrder" v-show="selectedWay === 'wx'"></div>
            <div id="qrcode-myOrder" v-show="selectedWay === 'ali'"></div>
            <div class="qrcode-tips">
              {{
                selectedWay === "wx"
                  ? "打开手机微信扫码支付"
                  : "打开手机支付宝扫码支付"
              }}
            </div>
            <div
              v-show="selectedWay === 'wx'"
              @click="refresh"
              class="qrcode-tips"
            >
              刷新
            </div>
            <div
              v-show="selectedWay === 'ali'"
              @click="refresh2"
              class="qrcode-tips"
            >
              刷新
            </div>
          </div>
        </div>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mockPay">一键支付</el-button>
      </div> -->
    </el-dialog>
  </section>
</template>

<script>
import QRCode from "qrcodejs2";
import { aliCode, wxCode, aliOrderQuery, wxOrderQuery } from "@/api/cart/cart";
import { mapGetters, mapActions } from "vuex";
import {
  apiGetUserOrderList,
  apiGetTotalGroup,
  apiAfterPay,
} from "@/api/user/order";
import OrderTable from "./components/OrderTable";
export default {
  name: "myOrder",
  components: { OrderTable },
  data() {
    return {
      orderNumber: null,
      codeUrl: null,
      codeUrl2: null,
      timer1: null,
      timer2: null,
      activeTab: "全部订单",
      allList: [],
      waitPayList: [],
      waitEvaluateList: [],
      completeList: [],
      cancelList: [],
      prevTabIndex: 0,
      tabModels: [
        {
          searchParams: {
            keyword: "",
            pageNum: 1,
            pageSize: 5,
          },
          status: null,
          total: 0,
          dataList: [],
        },
        {
          searchParams: {
            keyword: "",
            pageNum: 1,
            pageSize: 5,
          },
          status: 0,
          total: 0,
          dataList: [],
        },
        {
          searchParams: {
            keyword: "",
            pageNum: 1,
            pageSize: 5,
          },
          status: 1,
          total: 0,
          dataList: [],
        },
        {
          searchParams: {
            keyword: "",
            pageNum: 1,
            pageSize: 5,
          },
          status: 3,
          total: 0,
          dataList: [],
        },
        {
          searchParams: {
            keyword: "",
            pageNum: 1,
            pageSize: 5,
          },
          status: 2,
          total: 0,
          dataList: [],
        },
      ],
      modalShow: false,
      selectedWay: "wx",
      payDetail: {},
    };
  },
  provide() {
    return {
      refreshList: this.getCurrentTabList,
      callPay: this.handlePay,
    };
  },
  watch: {},
  filters: {
    paymentText(value) {
      let text = " - ";
      if (value || value === 0) {
        text = Number(value).toFixed(2);
      }
      return text;
    },
  },
  computed: {
    ...mapGetters(["getShoppingCart", "userId"]),
    currentTabIndex() {
      switch (this.activeTab) {
        case "全部订单":
          return 0;
        case "待付款":
          return 1;
        case "待评价":
          return 2;
        case "已完成":
          return 3;
        case "已取消":
          return 4;
      }
    },
  },
  activated() {
    this.getCurrentTabList();
    this.getStatusTotal();
  },
  beforeDestroy() {
    this.timer1 && clearInterval(this.timer1);
    this.timer2 && clearInterval(this.timer2);
  },
  methods: {
    handlePay(detail) {
      this.payDetail = detail;
      this.modalShow = true;
      this.orderNumber = this.payDetail.orderNumber;
      this.selectedWay === "wx" && this.getWxCode();
      this.selectedWay === "ali" && this.getAliCode();
      this.selectedWay === "wx" && this.wxOrderState();
      this.selectedWay === "ali" && this.aliOrderState();
    },
    mockPay() {
      // TODO:
      apiAfterPay({ id: this.payDetail.id }).then(() => {
        this.modalShow = false;
        this.$message.success("订单支付成功");
        this.timer1 && clearInterval(this.timer1);
        this.timer2 && clearInterval(this.timer2);
        setTimeout(() => {
          this.getCurrentTabList();
        }, 500);
      });
    },
    selectWay(value) {
      if (value === "wx") {
        this.selectedWay = "wx";
        this.getWxCode();
        clearInterval(this.timer2);
        clearInterval(this.timer1);
        this.wxOrderState();
      } else if (value === "ali") {
        this.selectedWay = "ali";
        this.getAliCode();
        clearInterval(this.timer1);
        clearInterval(this.timer2);
        this.aliOrderState();
      }
    },
    getWxCode() {
      // 获取微信二维码
      wxCode(this.orderNumber).then((res) => {
        let code = res.data ? res.data.qrCode : null;
        if (!code) {
          this.$message.error("获取支付二维码失败");
          const dom = document.getElementById("qrcode2-myOrder");
          if (dom) dom.innerHTML = "";
          return;
        }
        this.codeUrl2 = code;
        this.$nextTick(() => {
          this.createQrcode2();
        });
      });
    },
    getAliCode() {
      // 获取支付宝二维码
      aliCode(this.orderNumber).then((res) => {
        let code = res.data ? res.data.qrCode : null;
        if (!code) {
          this.$message.error("获取支付二维码失败");
          const dom = document.getElementById("qrcode-myOrder");
          if (dom) dom.innerHTML = "";
          return;
        }
        this.codeUrl = code;
        this.$nextTick(() => {
          this.createQrcode();
        });
      });
    },
    createQrcode() {
      // 若存在，先删除二维码
      const dom = document.getElementById("qrcode-myOrder");
      if (dom) dom.innerHTML = "";
      // 这里会自动去取模版中的id为qrcode的
      console.log("alidom", dom, this.codeUrl);
      const qrcode = new QRCode("qrcode-myOrder", {
        width: 150, // 宽
        height: 150, // 高
        text: this.codeUrl, // 链接地址
      });
      return qrcode;
    },
    createQrcode2() {
      // 若存在，先删除二维码
      const dom = document.getElementById("qrcode2-myOrder");
      if (dom) dom.innerHTML = "";
      console.log("wxdom", dom, this.codeUrl2);
      // 这里会自动去取模版中的id为qrcode的
      const qrcode = new QRCode("qrcode2-myOrder", {
        width: 150, // 宽
        height: 150, // 高
        text: this.codeUrl2, // 链接地址
      });
      return qrcode;
    },
    //刷新二维码
    refresh() {
      $(".qrcode").html(""); //把之前的置为空
      this.getWxCode();
    },
    //刷新二维码
    refresh2() {
      $(".qrcode").html(""); //把之前的置为空
      this.getAliCode();
    },
    // 轮询微信订单状态
    wxOrderState() {
      this.timer1 = setInterval(() => {
        wxOrderQuery(this.orderNumber, "web").then((res) => {
          if (res.code == 200) {
            clearInterval(this.timer1);
            this.modalShow = false;
            this.$message.success("订单支付成功");
            setTimeout(() => {
              this.getCurrentTabList();
              this.getStatusTotal();
            }, 800);
          }
        });
      }, 3000);
    },
    // 轮询支付宝订单状态
    aliOrderState() {
      this.timer2 = setInterval(() => {
        aliOrderQuery(this.orderNumber).then((res) => {
          if (res.code == 200) {
            clearInterval(this.timer2);
            this.modalShow = false;
            this.$message.success("订单支付成功");
            setTimeout(() => {
              this.getCurrentTabList();
              this.getStatusTotal();
            }, 800);
          }
        });
      }, 3000);
    },
    //当点击弹出框的关闭时
    closed() {
      this.timer1 && clearInterval(this.timer1);
      this.timer2 && clearInterval(this.timer2);
    },
    switchTab(e, v) {
      console.log("切换,", e, v);
      console.log("当前激活页及页码", this.activeTab, this.currentTabIndex);
      this.tabModels[this.prevTabIndex].searchParams.keyword = "";
      this.prevTabIndex = this.currentTabIndex;
      this.getCurrentTabList();
    },
    handleSearch(keyword) {
      console.log(
        "关键词：订单号或者商品名",
        keyword,
        this.tabModels[this.currentTabIndex].searchParams.keyword
      );
      this.getCurrentTabList();
    },
    //切换页尺寸
    changePageSize(val) {
      this.tabModels[this.currentTabIndex].searchParams.pageSize = val;
      this.getCurrentTabList();
    },
    changePageCurrent(val) {
      this.tabModels[this.currentTabIndex].searchParams.pageNum = val;
      this.getCurrentTabList();
    },
    getCurrentTabList() {
      let model = this.tabModels[this.currentTabIndex];
      let {
        searchParams: { pageNum, pageSize, keyword },
        status,
      } = model;
      let params = { status, pageSize, pageNum, userId: this.userId };
      params = keyword ? { ...params, keyword } : params;
      // console.log("订单列表参数：", params);
      apiGetUserOrderList(params).then((res) => {
        // console.log("订单列表返回：", res);
        let list = res.rows || [],
          total = res.total || 0;
        this.tabModels[this.currentTabIndex].dataList = list;
        this.tabModels[this.currentTabIndex].total = total;
      });
    },
    getStatusTotal() {
      apiGetTotalGroup({ userId: this.userId }).then((res) => {
        let { allCount, waitPayCount, talkCount, closeCount, finishCount } =
          res;
        this.tabModels[0].total = Number(allCount);
        this.tabModels[1].total = Number(waitPayCount);
        this.tabModels[2].total = Number(talkCount);
        this.tabModels[3].total = Number(finishCount);
        this.tabModels[4].total = Number(closeCount);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page.my-order ::v-deep {
  .header-tabs {
    position: relative;
    .el-tabs__nav-wrap {
      padding: 0 30px;
      height: 52px;
      border-bottom: 1px solid #f2f2f2;
    }
    .el-tabs__item {
      height: 52px;
      line-height: 52px;
      padding: 0 27px;
      &:nth-child(2) {
        padding-left: 10px;
      }
      &:last-child {
        padding-right: 0;
      }
      &.is-active {
        color: #2e9adb;
      }
    }
    .el-tabs__active-bar {
      background-color: #2e9adb;
    }
    .header-right {
      position: absolute;
      right: 30px;
      top: 0;
      height: 52px;
      display: flex;
      align-items: center;
    }
    .custom-search {
      padding: 0;
      border: none;
      height: 100%;
      align-items: center;
    }
  }
  .list-wrap {
    padding: 0 20px;
  }
  .pagination-box {
    padding: 24px 30px;
    text-align: right;
  }
}

.ou-modal.pay-modal ::v-deep {
  .el-dialog__body {
    padding-bottom: 0;
  }
}

.pay-modal-wrap {
  .info-row {
    display: flex;
    align-items: center;
    padding: 8px;
  }
}

.price-span {
  font-size: 18px;
  font-weight: 400;
  color: #ff5353;
  margin-left: 16px;
  &::before {
    content: "¥";
  }
}

.pay-way-wrap {
  padding: 28px 20px 34px;
  display: flex;
  justify-content: space-between;
  .pay-box {
    width: 180px;
    height: 56px;
    position: relative;
    box-sizing: border-box;
    border: 1px solid #f2f2f2;
    cursor: pointer;
    .box-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.active {
      border: 1px solid #2e9adb;
    }
    .select-flag {
      position: absolute;
      bottom: -1px;
      right: 0;
    }
  }
}

.qrcode-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 20px 48px;
  flex-direction: column;
  .qrcode-img {
    width: 150px;
    height: 150px;
  }
  .qrcode-tips {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    margin-top: 20px;
    cursor: pointer;
  }
  .qrcode-tips:last-of-type {
    cursor: pointer;
  }
}
.dialog-footer ::v-deep {
  text-align: center;
  .el-button {
    width: 200px;
    font-size: 16px;
    padding: 8px 20px;
    background-color: #2e9adb;
    border-radius: 6px;
  }
}
</style>
